import React from 'react';
import { LabelBadge } from '@saucelabs/sl-component-label';
import { HStack } from '@saucelabs/sl-component-grid';

import { SectionTitle } from '../Layout/SectionTitle';

interface TitleProps {
  children?: React.ReactNode
  icon: React.ReactNode
  name: string
  isLegacy: boolean
}
export const Title: React.FC<TitleProps> = ({ children = null, icon: Icon, name, isLegacy }) => (
  <SectionTitle>
    <HStack
      alignItems="center"
      gap={2}
      justifyContent="space-between"
    >
      <div className="flex items-center">
        { Icon && <Icon className="text-gray-500 fill-current" /> }
        {name}
        {isLegacy && (
          <span className="-mt-0.5 ml-0.5">
            <LabelBadge color="orange">Legacy plan</LabelBadge>
          </span>
        )}
      </div>
      <div>
        {children}
      </div>
    </HStack>
  </SectionTitle>
);
